import styled, { css } from "styled-components";

export const StyledLink = styled.a`
    ${({ font, theme }) => font ? css(font) : theme.fonts.mulishRegular};
    font-size: 11px;
    line-height: 1.2em;
    letter-spacing: -0.025em;
    color: ${({ theme, color }) => color ? color :  theme.colors.purple};
    cursor: pointer;
    ${({ underline }) => underline === 'none' && css`
        text-decoration: none;
    `};
    ${({ underline }) => underline === 'hover' && css`
        text-decoration: none;
        :hover {
            text-decoration: underline;
        }
    `};
    ${({ underline }) => underline === 'always' && css`
        text-decoration: underline;
    `};
`;